export default __webpack_public_path__ + "static/media/5a0596df9cf05203c4b60445.af86ac59.png";